export default __webpack_public_path__ + "static/media/drumrole.ed1c1b94.mp3";